var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 10,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 10,
    fill: "url(#paint0_linear_5420_12948)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5420_12948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.6054 8.09375L22.6799 16.2083L24.7003 11.4208L33.6054 8.09375Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeWidth: 0.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3833 8.09375L19.2209 16.2851L17.2994 11.4208L8.3833 8.09375Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6745 26.9023L26.7646 31.3604L32.9905 33.0733L34.7803 27.0012L29.6745 26.9023Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23047 27.0012L9.00929 33.0733L15.2352 31.3604L12.3254 26.9023L7.23047 27.0012Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8838 19.3713L13.1489 21.9956L19.3309 22.2701L19.1113 15.627L14.8838 19.3713Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.105 19.37L22.8227 15.5488L22.6799 22.2688L28.8509 21.9943L27.105 19.37Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2351 31.3622L18.9465 29.5504L15.7402 27.0469L15.2351 31.3622Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0422 29.5504L26.7646 31.3622L26.2485 27.0469L23.0422 29.5504Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7648 31.3606L23.0425 29.5488L23.339 31.9755L23.306 32.9967L26.7648 31.3606Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeWidth: 0.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2354 31.3606L18.6942 32.9967L18.6722 31.9755L18.9467 29.5488L15.2354 31.3606Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeWidth: 0.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7491 25.4418L15.6526 24.5305L17.8377 23.5312L18.7491 25.4418Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.24 25.4418L24.1514 23.5312L26.3474 24.5305L23.24 25.4418Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2352 31.3604L15.7623 26.9023L12.3254 27.0012L15.2352 31.3604Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2375 26.9023L26.7646 31.3604L29.6744 27.0012L26.2375 26.9023Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8509 21.9941L22.6799 22.2687L23.2509 25.442L24.1623 23.5314L26.3584 24.5306L28.8509 21.9941Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6525 24.5306L17.8485 23.5314L18.7489 25.442L19.3309 22.2687L13.1489 21.9941L15.6525 24.5306Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1489 21.9941L15.7403 27.0451L15.6525 24.5306L13.1489 21.9941Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3583 24.5306L26.2485 27.0451L28.8509 21.9941L26.3583 24.5306Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.331 22.2695L18.749 25.4429L19.4737 29.1872L19.6384 24.257L19.331 22.2695Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.68 22.2695L22.3835 24.246L22.5153 29.1872L23.251 25.4429L22.68 22.2695Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2511 25.4426L22.5154 29.1869L23.0424 29.5493L26.2487 27.0458L26.3585 24.5312L23.2511 25.4426Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6526 24.5312L15.7404 27.0458L18.9467 29.5493L19.4738 29.1869L18.7491 25.4426L15.6526 24.5312Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3059 32.9974L23.3389 31.9762L23.0644 31.7347H18.9248L18.6722 31.9762L18.6942 32.9974L15.2354 31.3613L16.4432 32.3496L18.8918 34.0515H23.0973L25.5569 32.3496L26.7648 31.3613L23.3059 32.9974Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0423 29.5499L22.5153 29.1875H19.4737L18.9466 29.5499L18.6721 31.9765L18.9247 31.735H23.0643L23.3388 31.9765L23.0423 29.5499Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0666 16.7353L34.9999 12.2553L33.6054 8.09375L23.0422 15.9338L27.105 19.3706L32.8477 21.0506L34.1215 19.5683L33.5724 19.173L34.4509 18.3714L33.7701 17.8443L34.6485 17.1745L34.0666 16.7353Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 12.2553L7.93333 16.7353L7.34039 17.1745L8.21882 17.8443L7.54902 18.3714L8.42745 19.173L7.87843 19.5683L9.14118 21.0506L14.8839 19.3706L18.9467 15.9338L8.38353 8.09375L7 12.2553Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8478 21.0511L27.105 19.3711L28.8509 21.9954L26.2485 27.0464L29.6744 27.0025H34.7803L32.8478 21.0511Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8838 19.3711L9.14106 21.0511L7.23047 27.0025H12.3254L15.7403 27.0464L13.1489 21.9954L14.8838 19.3711Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.68 22.2685L23.0423 15.9329L24.7113 11.4199H17.2996L18.9466 15.9329L19.3309 22.2685L19.4627 24.267L19.4737 29.1862H22.5152L22.5372 24.267L22.68 22.2685Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5420_12948",
    x1: 0.00000253586,
    y1: -8,
    x2: 73,
    y2: 79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFBDA0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC9463"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5420_12948"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.3791c4a2e284e7d6912cd41305fb46c8.svg";
export { ForwardRef as ReactComponent };